import { BookingsFeedbackReportData } from '@app/features/reports/domain/BookingsFeedbackReportData'
import {
    BookingsFeedbackReportDataDTO,
} from '@app/features/reports/services/DTO/BookingsFeedbackReportDataDTO'
import { DTOAdapter } from '@services/DTOAdapter'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { Helper } from '@app/helpers/utilities/helper'

@Injectable({
    providedIn: 'root',
})
export class BookingsFeedbackReportService {

    constructor(
        private http: HttpClient,
        private dtoAdapter: DTOAdapter
    ) { }

    fetchData(
        businessId: string,
        venueId: string,
        startDateTime: Date,
        endDateTime: Date
    ): Observable<BookingsFeedbackReportData[]>{
        const path =
            `/organisation/business/${businessId}/venue/${venueId}/report/bookings-feedback/data`
        const url = new URL(path, environment.apiBaseURL)
        const params = new HttpParams()
            .set('startDate', Helper.makeLocalISOFormattedDateTimeString(startDateTime))
            .set('endDate', Helper.makeLocalISOFormattedDateTimeString(endDateTime))

        return this.http.get<BookingsFeedbackReportDataDTO[]>(url.toString(), { params: params })
            .pipe(
                map(dto => dto.map(
                    value => this.dtoAdapter.adaptBookingsFeedbackReportDataDto(value)
                    ).sort((a, b) => a.startTime.getTime() - b.startTime.getTime())
                )
            )
    }

    fetchCustomerData(
        businessId: string,
        venueId: string,
        customerId: string
    ): Observable<BookingsFeedbackReportData[]> {
        const path =
            `/organisation/business/${businessId}/venue/${venueId}/report/bookings-feedback/customer/${customerId}/data`
        const url = new URL(path, environment.apiBaseURL)

        return this.http.get<BookingsFeedbackReportDataDTO[]>(url.toString())
            .pipe(
                map(dto => dto.map(
                    value => this.dtoAdapter.adaptBookingsFeedbackReportDataDto(value)
                    ).sort((a, b) => b.feedbackDateCreated.getTime() - a.feedbackDateCreated.getTime())
                )
            )
    }
}
